import React, { useContext, useMemo } from 'react';

//Highcharts
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official'
import HighchartsItemSeries from "highcharts/modules/item-series";
import HighchartsData from "highcharts/modules/data";
import HighchartsAccessibility from "highcharts/modules/accessibility";

//Context
import { FilterContext } from '../../context/FilterContext';
import DataHandling from '../../utils/DataHandling';
import {config_lineChartEV} from '../../models/diagramsConfig';
import {GetDataContext} from '../../context/GetDataContext';

//Components
import PollingCompanies from '../Menus/polling-companies';

//Highcharts Modules
HighchartsItemSeries(Highcharts);
HighchartsData(Highcharts);
HighchartsAccessibility(Highcharts);


const RegressionV2Ev = () => {
    
    //Data
    const {evData,  appConfigOptions } = useContext(GetDataContext);

    //Filtering
    const {filter} = useContext(FilterContext);
    

    useMemo(() => {
        if (evData.data.length > 0) {
            DataHandling(evData, filter, appConfigOptions)
        }
    },[ evData, filter,  appConfigOptions])

    return (
        <div className='regression'>
            <section className={'container container-evaluation'}>
                <div className={'container_header'}>
                    <h2 className={'section__title'}>{"ΕΚΤΙΜΗΣΗ ΨΗΦΟΥ"}</h2>
                    <PollingCompanies />
                </div>
                <HighchartsReact highcharts={Highcharts} options={config_lineChartEV} updateArgs={[true, true, true]}/>
            </section>
        </div>
        
    );
};

export default RegressionV2Ev;
